const webshops = {
    'clients.webshops.add': 'Webshop toevoegen',
    'clients.webshops.edit': 'Webshop bewerken',

    'clients.webshops.api_settings': 'API-instellingen',
    'clients.webshops.host': 'Host',
    'clients.webshops.username': 'Gebruikersnaam',
    'clients.webshops.password': 'Wachtwoord / API sleutel',
    'clients.webshops.consumer_key': 'Klantsleutel',
    'clients.webshops.consumer_secret': 'Klantgeheim',
    'clients.webshops.sync_settings': 'Synchronisatie instellingen',
    'clients.webshops.compare_prices': 'Vergelijk prijzen',
    'clients.webshops.infobar.compare_prices': 'Prijsvergelijking zal eerst worden toegepast op matchende EAN nummers van producten. Als er geen match is zullen de vergelijkingen op product codes worden toegepast.',
};

export default webshops;
